import { FormEvent, useState } from 'react';

const FORM_ID = 'dailbs3p14a1h3mr7630';
const SUBMIT_ADDR = 'https://readdy.ai/api/form/dailbs3p14a1h3mr7630';

export default function SubscribeForm() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const honeypot = String(formData.get('website_alt') || '').trim();
    if (honeypot) {
      setStatus('success');
      return;
    }

    setStatus('loading');
    setFormError('');

    const payload = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key === 'website_alt') return;
      payload.append(key, String(value));
    });

    try {
      const response = await fetch(SUBMIT_ADDR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });
      const responseText = await response.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '';
      const isSpam = /spam/i.test(serverMsg);
      const ok = response.ok && parsed?.code === 'OK' && !isSpam;

      if (ok) {
        setStatus('success');
        form.reset();
      } else {
        setStatus('error');
        setFormError(serverMsg || '提交失败，请稍后重试。');
      }
    } catch {
      setStatus('error');
      setFormError('网络异常，请稍后重试。');
    }
  };

  return (
    <section id="subscribe" className="scroll-mt-24 bg-accent-900 py-16 md:py-20">
      <div className="mx-auto w-full max-w-5xl px-4 md:px-8">
        <div className="flex flex-col gap-8 md:flex-row md:items-center md:justify-between">
          <div className="md:max-w-md">
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-800 px-3 py-1 text-xs font-medium tracking-wide text-background-100">
              <i className="ri-mail-send-line" />
              爆料速递
            </span>
            <h2 className="font-heading mt-4 text-2xl font-bold text-background-50 md:text-3xl">
              每周一封，只寄深度
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-accent-100">
              把本周最值得读的深度拆解整理成一封邮件，包含事件时间线、核心争议与我们的观察清单，无广告，随时可退订。
            </p>
          </div>

          <div className="w-full md:max-w-md">
            {status === 'success' ? (
              <div className="flex items-start gap-3 rounded-lg bg-background-50 p-5">
                <i className="ri-checkbox-circle-fill mt-0.5 text-xl text-accent-600" />
                <div>
                  <p className="text-sm font-medium text-foreground-950">订阅成功，欢迎加入</p>
                  <p className="mt-1 text-xs text-foreground-600">
                    下一封《爆料速递》将在本周四发出，请留意邮箱。
                  </p>
                </div>
              </div>
            ) : (
              <form
                onSubmit={handleSubmit}
                data-readdy-form
                id={FORM_ID}
                className="flex flex-col gap-3 sm:flex-row"
              >
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="你的邮箱地址"
                  className="w-full rounded-md border border-accent-700 bg-accent-950 px-4 py-3 text-sm text-background-50 placeholder:text-accent-300 focus:border-secondary-400 focus:outline-none focus:ring-2 focus:ring-secondary-500/30"
                />
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="bailiao-extra-field"
                />
                <button
                  type="submit"
                  disabled={status === 'loading'}
                  className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 disabled:opacity-60"
                >
                  {status === 'loading' ? '提交中…' : '免费订阅'}
                </button>
              </form>
            )}
            {status === 'error' && <p className="mt-2 text-xs text-secondary-200">{formError}</p>}
            {status !== 'success' && (
              <p className="mt-3 text-xs text-accent-200">
                提交即表示同意我们仅将该邮箱用于发送内容速递。
              </p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}